export default {
  clientProfile: '/profile/client',
  memberProfile: '/profile/member',
};
